(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("zinput", [], factory);
	else if(typeof exports === 'object')
		exports["zinput"] = factory();
	else
		root["zinput"] = factory();
})(window, function() {
return 